<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 26 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19.2308 19.505C17.8043 17.6224 15.5442 16.4062 13 16.4062C10.4558 16.4062 8.19572 17.6224 6.76923 19.505M19.2308 19.505C21.1599 17.7879 22.375 15.2858 22.375 12.5C22.375 7.32233 18.1777 3.125 13 3.125C7.82233 3.125 3.625 7.32233 3.625 12.5C3.625 15.2858 4.84011 17.7879 6.76923 19.505M19.2308 19.505C17.5745 20.9793 15.3918 21.875 13 21.875C10.6082 21.875 8.42553 20.9793 6.76923 19.505M16.125 10.1562C16.125 11.8821 14.7259 13.2812 13 13.2812C11.2741 13.2812 9.875 11.8821 9.875 10.1562C9.875 8.43036 11.2741 7.03125 13 7.03125C14.7259 7.03125 16.125 8.43036 16.125 10.1562Z"
				:stroke="color"
				stroke-width="1.56"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgProfile',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
